<template>
  <div class="grid-view">
    <div
      v-show="!quotationDetail.visible || [SystemConstants.QUOTATION_TYPE_PRE_PORT.code, SystemConstants.QUOTATION_TYPE_LAST_MILE.code].indexOf(quotationType) === -1"
      class="main-content"
    >
      <div style="width: 100%; padding-top: 5px;">
        <div v-show="showSimple" class="cargo-advance-search-header">
          <div class="cargo-advance-search-toggle-trigger">
            <i
              v-show="showAdv"
              class="el-icon-arrow-left"
              :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
              @click="upOrDownSearchCondition"
            />
          </div>
          <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
            <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
            <el-input
              ref="keyword"
              v-model="keyWords"
              no="keyWords"
              style="width:200px;"
              :placeholder="simQueryPlaceholder"
              :spellcheck="false"
              @blur="keyWordBlur"
              @keyup.enter.native.prevent="toQuery"
            />
          </div>
          <div ref="searchOperations" class="cargo-advance-search-operations">
            <slot name="operations">
              <!--页面操作按钮-->
              <div>
                <el-button no="toQuery" style="margin-left: 10px" type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                <el-button no="resetSearch" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
                <el-button v-if="!isPrePortOrLastMile" no="onCopy" type="primary" @click="onCopy()">{{ $t('Pricing.Copy') }}</el-button>
                <el-button v-if="inputAllowed" no="inputAllowed" type="primary" @click="onQuotation()">{{ $t('Pricing.Add') }}</el-button>
                <el-button v-if="isDelete" no="isDelete" type="danger" @click="onDelete()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
              </div>
            </slot>
          </div>
        </div>
        <div v-if="showAdv" v-show="isShowingMoreSearchCondition" class="cargo-advance-search-more">
          <div class="cargo-advance-search-more-operations">
            <el-form label-width="60px" label-position="left" :inline="true">
              <el-form-item :label="$t('Pricing.QuotationNo')">
                <el-input v-model="filter.quotationNo" no="quotationNo" style="width:190px;" />
              </el-form-item>
              <el-form-item :label="$t('Pricing.POL')">
                <cargo-advance-select
                  v-if="quotationType!=PriceConstant.QUOTATION_AIR"
                  no="pol"
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:190px;"
                  :default-value="filter.pol"
                  @parentCallBack="p=>{filter.pol=p.value}"
                />
                <cargo-advance-select
                  v-if="quotationType==PriceConstant.QUOTATION_AIR"
                  no="pol1"
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:190px;"
                  :default-value="filter.pol"
                  @parentCallBack="p=>{filter.pol=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.POD')">
                <cargo-advance-select
                  v-if="quotationType!=PriceConstant.QUOTATION_AIR"
                  no="pod"
                  filterable
                  :placeholder="$t('Pricing.PODPrompt')"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:190px;"
                  :default-value="filter.pod"
                  @parentCallBack="p=>{filter.pod=p.value}"
                />
                <cargo-advance-select
                  v-if="quotationType==PriceConstant.QUOTATION_AIR"
                  no="pod1"
                  filterable
                  :placeholder="$t('Pricing.PODPrompt')"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:190px;"
                  :default-value="filter.pod"
                  @parentCallBack="p=>{filter.pod=p.value}"
                />
              </el-form-item>
              <el-form-item>
                <el-select v-model="filter.ddlClientType" no="ddlClientType" style="width:100px;">
                  <el-option
                    v-for="(item,index) in PriceConstant.CLIENT_TYPE_LIST"
                    :key="index"
                    :label="isZh ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <!--正式客户-->
                <cargo-company-select
                  v-if="filter.ddlClientType === 1"
                  no="clientId"
                  :method-params="{customer:true,active:true}"
                  :default-value="filter.clientId || undefined"
                  style="width:190px;"
                  @change="p=>{filter.clientId=p.value}"
                />
                <!--临时客户-->
                <cargo-advance-select
                  v-if="filter.ddlClientType === 0"
                  no="clientId1"
                  :custom-label="(item)=>`[${branchMap.get(item.branchId)}]${item.name}`"
                  :show-custom-label-in-option="true"
                  filterable
                  :default-value="filter.clientId || undefined"
                  :cache="false"
                  tag-name="name"
                  tag-value="clientId"
                  style="width:190px;"
                  :filter-tag-names="['code','name']"
                  :static-options="filter.clientList"
                  @parentCallBack="p=>{filter.clientId=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Sales')">
                <!-- TODO-->
                <!-- <cargo-advance-select
                    :select-type="selectTypeNames.static_data_User"
                    :cache="false"
                    filterable
                    :default-value="filter.sales||''"
                    :static-options="filter.salesList"
                    :callback-params="{key:'userId'}"
                    style="width:190px;"
                    @parentCallBack="p=>{filter.sales=p.value}"
                  />-->

                <cargo-user-select
                  ref="salesSelect"
                  no="sales"
                  :method-params="{officeId:$store.getters.currentOfficeId}"
                  :default-value="filter.sales || undefined"
                  :callback-params="{key:'userId'}"
                  style="width:190px;"
                  @change="p=>{filter.sales=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.CreatedDate')">
                <el-date-picker v-model="filter.beginDate" no="beginDate" style="width:190px;" type="date" value-format="yyyy-MM-dd" />&nbsp;{{ $t('Pricing.EndDate') }}
                <el-date-picker v-model="filter.endDate" no="endDate" style="width:190px;" type="date" value-format="yyyy-MM-dd" />
              </el-form-item>
              <el-form-item :label="$t('Pricing.IsBooked')" label-width="180">
                <el-select v-model="filter.ddlIsBooked" no="ddlIsBooked" style="width:140px;">
                  <el-option
                    v-for="(item,index) in PriceConstant.CLIENT_IS_BOOKED_LIST"
                    :key="index"
                    :label="isZh ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Pricing.BeginDate')">
                <el-date-picker
                  v-model="filter.beginDateCol"
                  no="beginDateCol"
                  type="date"
                  style="width:180px;"
                  :picker-options="{
                    disabledDate: time => {
                      return ( time.getTime() > new Date(filter.endDateCol + ' 23:59:59').getTime() )
                    }
                  }"
                  value-format="yyyy-MM-dd"
                />
                <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
                <el-date-picker
                  v-model="filter.endDateCol"
                  no="endDateCol"
                  type="date"
                  style="width:180px;"
                  :picker-options="{
                    disabledDate: time => {
                      return (
                        time.getTime() <
                        new Date(filter.beginDateCol + ' 00:00:00').getTime()
                      )
                    }
                  }"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_amount')">
                <el-input-number
                  v-model="limited"
                  no="limited"
                  :min="300"
                  :max="3000"
                  :precision="0"
                  controls-position="right"
                  style="width:100px"
                  @blur="selectBlur"
                />
              </el-form-item>
              <!--询价编号-->
              <el-form-item :label="$t('CargoMsg.Cargo_EnquiryNumber')">
                <el-input v-model="filter.inquiryPriceNo" no="inquiryPriceNo" style="width:190px;" />
              </el-form-item>
              <!--关联港前报价单号-->
              <el-form-item
                v-if="[PriceConstant.QUOTATION_PRE_PORT, PriceConstant.QUOTATION_LAST_MILE].indexOf(quotationType) === -1"
                label-width="200"
                :label="$t('CargoMsg.Cargo_AssociatedPrePortQuoteNumber')"
              >
                <el-input v-model="filter.prePortQuotationNo" no="prePortQuotationNo" style="width:190px;" />
              </el-form-item>
              <!--关联尾程报价单号-->
              <el-form-item
                v-if="[PriceConstant.QUOTATION_PRE_PORT, PriceConstant.QUOTATION_LAST_MILE].indexOf(quotationType) === -1"
                label-width="200"
                :label="$t('CargoMsg.Cargo_AssociatedLastMileQuoteNumber')"
              >
                <el-input v-model="filter.lastMileQuotationNo" no="lastMileQuotationNo" style="width:190px;" />
              </el-form-item>
              <!--报价状态-->
              <el-form-item :label="$t('FbaJob.quotationStatus')" label-width="180">
                <el-select v-model="filter.status2" no="status2" style="width:140px;" clearable @clear="filter.status2 = null">
                  <el-option
                    v-for="(item,index) in SystemConstants.QUOTE_STATUS"
                    :key="index"
                    :label="isZh ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <!--报价方式-->
              <el-form-item :label="$t('CargoMsg.Cargo_QuoteMethod')" label-width="180">
                <el-select v-model="filter.quotationMethod" no="quotationMethod" style="width:140px;" clearable @clear="filter.quotationMethod = null">
                  <el-option
                    v-for="(item,index) in SystemConstants.QUOTATION_METHODS"
                    :key="index"
                    :label="isZh ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <cargo-left-right-resize
        :left-style="{display: 'flex', flexDirection: 'column',width: isPrePortOrLastMile ? '100%' : '60%'}"
        :right-style="{display: 'flex', flexDirection: 'column',width: isPrePortOrLastMile ? '0%' : '40%'}"
        style="height: 100%"
      >
        <template
          slot="left"
        >
          <div class="section grid-wrapper" style="min-height:350px">
            <cargo-ag-grid
              :key="'22020200'+quotationType"
              :config-module="'22020200'+quotationType"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="flex: 1"
              @gridReady="onGridReady"
            />
          </div>
        </template>
        <template
          v-if="!isPrePortOrLastMile"
          slot="right"
        >
          <div class="section grid-wrapper" style="min-height:350px">
            <!--整箱-->
            <cargo-ag-grid
              v-if="quotationType === PriceConstant.QUOTATION_FCL"
              key="22020201"
              config-module="22020201"
              :grid-params.sync="fcl.gridParams"
              :grid-options="fcl.gridOptions"
              :column-defs="fcl.columnDefs"
              :row-data="fcl.rowData"
              style="flex: 1"
              @gridReady="onFclGridReady"
            />
            <!--拼箱-->
            <cargo-ag-grid
              v-if="quotationType === PriceConstant.QUOTATION_LCL"
              key="22020202"
              config-module="22020202"
              :grid-params.sync="lcl.gridParams"
              :grid-options="lcl.gridOptions"
              :column-defs="lcl.columnDefs"
              :row-data="lcl.rowData"
              style="flex: 1"
              @gridReady="onLclGridReady"
            />
            <!--空运-->
            <cargo-ag-grid
              v-if="quotationType === PriceConstant.QUOTATION_AIR"
              key="22020203"
              config-module="22020203"
              :grid-params.sync="air.gridParams"
              :grid-options="air.gridOptions"
              :column-defs="air.columnDefs"
              :row-data="air.rowData"
              style="flex: 1"
              @gridReady="onAirGridReady"
            />
            <!--港前-->
            <cargo-ag-grid
              v-if="quotationType === PriceConstant.QUOTATION_PRE_PORT"
              key="22020531"
              config-module="22020531"
              :grid-params.sync="prePort.gridParams"
              :grid-options="prePort.gridOptions"
              :column-defs="prePort.columnDefs"
              :row-data="prePort.rowData"
              style="flex: 1"
              @gridReady="onPrePortGridReady"
            />
            <!--尾程-->
            <cargo-ag-grid
              v-if="quotationType === PriceConstant.QUOTATION_LAST_MILE"
              key="22020532"
              config-module="22020532"
              :grid-params.sync="lastMile.gridParams"
              :grid-options="lastMile.gridOptions"
              :column-defs="lastMile.columnDefs"
              :row-data="lastMile.rowData"
              style="flex: 1"
              @gridReady="onLastMileGridReady"
            />
          </div>
        </template>
      </cargo-left-right-resize>

      <div class="pagination-wrapper">
        <div class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>

    <!--详情-->
    <quotation-detail-dialog
      v-if="quotationDetail.visible &&
        [SystemConstants.QUOTATION_TYPE_PRE_PORT.code, SystemConstants.QUOTATION_TYPE_LAST_MILE.code].indexOf(quotationType) === -1"
      :visible.sync="quotationDetail.visible"
      :model="quotationDetail.quotation"
      :editing="quotationDetail.isEditing"
      :show-quotation-detail="quotationDetail.showDetail"
      :is-edit-all="isEditAll"
      @saveSuccess="saveSuccess"
    />

    <!--港前 报价详情-->
    <quotation-pre-port-detail
      v-if="quotationDetail.visible && SystemConstants.QUOTATION_TYPE_PRE_PORT.code === quotationType"
      ref="quotationDetail"
      :is-edit-all="isEditAll"
      @cancel="quotationDetail.visible = false"
      @back="quotationDetail.visible = false"
    />

    <!--尾程 报价详情-->
    <quotation-last-mile-detail
      v-if="quotationDetail.visible && SystemConstants.QUOTATION_TYPE_LAST_MILE.code === quotationType"
      ref="quotationDetail"
      :is-edit-all="isEditAll"
      @cancel="quotationDetail.visible = false"
      @back="quotationDetail.visible = false"
    />
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { queryQuotation, copyQuotation, deleteQuotationFunc } from '@/api/price/quotation'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { PriceAirUtil } from '@/class/cargo/model/utils/PriceAirUtil'
import { getLoading } from '@/utils/utilBaseElement'
import QuotationDetailDialog from '@/views/cargo/v0/Price/Quotation/components/quotationDetailDialog'
import $store from '@/store'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import DateUtils from '@/utils/dateUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { Quotation } from '@/class/model/price/Quotation'
import { getAllUsersByOffice, getJuniorSales } from '@/api/user'
import { queryQuotationClient } from '@/api/sales/quotationClient'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey } from '@/utils/basicDataCache'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import quotationPrePortDetail from '@/components/Cargo/Quotation/quotationPrePortDetail'
import quotationLastMileDetail from '@/components/Cargo/Quotation/quotationLastMileDetail'
import { deepClone } from '@/utils'
import { QUOTATION_LAST_MILE, QUOTATION_PRE_PORT } from '@/class/cargo/model/parameters/PriceConstant'
import { QUOTATION_METHODS } from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { QUOTE_STATUS_PENDING } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'QuotationList',
  components: {
    QuotationDetailDialog, cargoUserSelect, cargoLeftRightResize, quotationPrePortDetail, quotationLastMileDetail,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect, cargoCompanySelect
  },
  props: {
    quotationType: { type: Number, request: true, default: -1 }, // 类型 0：整箱 1：空运 2：拼箱
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    showSimple: { type: Boolean, default: true } // 显示简单UI查询
  },
  data() {
    return {
      PriceConstant, SystemConstants,
      URL,
      toExoSystemHC: false,
      limited: 300,
      documentManage: new DocumentManage(),
      selectedItem: null,
      selectTypeNames: TYPE_NAMES,
      simQueryPlaceholder: this.$t('Pricing.PlsInputQuotationNo'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        quotationNo: '',
        pol: '',
        pod: '',
        ddlClientType: 0, // 客户类型
        clientId: 0, // 客户ID
        clientList: [],
        sales: 0,
        salesList: [], // 销售下拉数据源
        ddlIsBooked: -1,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        beginDateCol: '', // 有效期自
        endDateCol: '', // 有效期止
        inquiryPriceNo: '', // 询价编号
        prePortQuotationNo: '', // 关联港前报价单号
        lastMileQuotationNo: '', // 关联尾程报价单号
        status2: null, // 报价状态
        quotationMethod: null // 报价方式
      },
      filterJson: {},
      keyWords: null,
      rowData: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: false,
        suppressRowSelection: false,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.changeQuotation(event.data) }
      },
      gridParams: {},
      gridApi: null,
      commonColumnDefs: [
        { headerName: this.$t('Pricing.QuotationNo'), field: 'quotationNo', colId: 'quotationNo', width: 200 },
        { headerName: this.$t('Pricing.Details'), field: '', colId: '', width: 200, suppressMenu: true,
          cellRenderer: (params) => {
            const methodPath = this.documentManage.getPath('onViewDetail')
            return `<a onclick="${methodPath}('${params.data.uuid}')" style="color:#1605FB; text-decoration: underline;">${this.$t('Pricing.Details')}</a>`
          }
        },
        { headerName: this.$t('Pricing.PlaceOfReceipt'), field: 'receiptPlace', colId: 'receiptPlace', width: 200 },
        { headerName: this.$t('Pricing.PlaceOfDelivery'), field: 'deliveryPlace', colId: 'deliveryPlace', width: 200 },
        {
          headerName: this.$t('Pricing.POL'),
          field: 'pol',
          colId: 'pol',
          cellRenderer: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.POD'),
          field: 'pod',
          colId: 'pod',
          cellRenderer: (params) => {
            const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            return !value ? params.value : value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.Client'),
          field: 'clientName',
          colId: 'clientName',
          cellRenderer: (params) => {
            const clientType = params.data && params.data.clientType ? parseInt(params.data.clientType) : 0
            const clientId = params.data && params.data.clientId ? parseInt(params.data.clientId) : 0
            if (clientType > 0 && clientId > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', clientId, this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName')
            }
            return params.value
          },
          width: 200
        },
        {
          headerName: this.$t('Pricing.Weight'), field: 'grossWeight', colId: 'grossWeight', width: 200
        },
        {
          headerName: this.$t('Pricing.Volume'), field: 'cubage', colId: 'cubage', width: 200
        },
        { headerName: this.$t('Pricing.quantity'), field: 'quantity', colId: 'quantity', width: 200 },
        { headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', width: 200 },
        { headerName: this.$t('Pricing.BusinessType'), field: 'jobType', colId: 'jobType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobTypeLabelFunc(params.value, params.data)
          }
        },
        {
          headerName: this.$t('Pricing.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName')
          },
          width: 200
        },
        { headerName: this.$t('Pricing.Goods'), field: 'goodsName', colId: 'goodsName', width: 200 },
        { headerName: 'HSCODE', field: 'hsCode', colId: 'hsCode', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          } },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', colId: 'jobNo', width: 200 },
        { headerName: this.$t('Pricing.IsBooked'), field: 'jobNo', colId: 'jobNo', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.IsBookedLabelFunc(params.value)
          } },
        {
          headerName: this.$t('CargoMsg.Cargo_QuoteMethod'),
          colId: 'quotationMethod',
          field: 'quotationMethod',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.QUOTATION_METHODS) || ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnquiryNumber'),
          field: 'inquiryPriceNo',
          colId: 'inquiryPriceNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssociatedPrePortQuoteNumber'),
          field: 'prePortQuotationNo',
          colId: 'prePortQuotationNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssociatedLastMileQuoteNumber'),
          field: 'lastMileQuotationNo',
          colId: 'lastMileQuotationNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssociatedLastMileQuoteNumber'),
          field: 'lastMileQuotationNo',
          colId: 'lastMileQuotationNo',
          width: 200
        },
        {
          headerName: this.$t('FbaJob.quotationStatus'),
          colId: 'status2',
          field: 'status2',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.QUOTE_STATUS)
          }
        }
      ],
      fcl: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'),
            field: 'pol',
            colId: 'pol',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Source'),
            field: 'source',
            colId: 'source',
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.POD'),
            field: 'pod',
            colId: 'pod',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Direct'),
            field: 'direct',
            colId: 'direct',
            cellRenderer: (params) => {
              return ColumnUtils.boolLabelFunc(params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            }
          },
          {
            headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
            tooltip: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            }
          },
          { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
          { headerName: this.$t('Pricing.ServiceMode'), field: 'serviceMode', colId: 'serviceMode', width: 200 },
          { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200 },
          { headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200 },
          { headerName: 'All In 20\'', field: 'eq20', colId: 'eq20', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: 'All In 40\'', field: 'eq40', colId: 'eq40', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: 'All In 40\'HC', field: 'eqHc', colId: 'eqHc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          }, { headerName: 'All In 45\'', field: 'eq45', colId: 'eq45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Sum'), field: 'amount', colId: 'amount', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost20'), field: 'cost20', colId: 'cost20', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost40'), field: 'cost40', colId: 'cost40', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.CostHC'), field: 'costHc', colId: 'costHc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost45'), field: 'cost45', colId: 'cost45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.VAT'), field: 'vat', colId: 'vat', width: 200 },
          { headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnPaymentFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200 },
          { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200 },
          { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200 },
          { headerName: this.$t('Pricing.Commodity'), field: 'commodity', colId: 'commodity', width: 200 },
          { headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.shareColumnLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
          { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200 },
          { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 },
          { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
            valueFormatter: (params) => {
              return CommonState.getNameByCode(PriceConstant.PRICE_ALL_TYPES, params.value)
            }
          },
          { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
          },
          { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
          },
          { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }
        ]
      },
      lcl: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'),
            field: 'pol',
            colId: 'pol',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.POD'),
            field: 'pod',
            colId: 'pod',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            }
          },
          {
            headerName: this.$t('Pricing.Source'),
            field: 'source',
            colId: 'source',
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            width: 200
          },
          { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200 },
          {
            headerName: this.$t('Pricing.WeightPrice'), field: 'weightPrice', colId: 'weightPrice', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return ColumnUtils.formatNumber(params.value, 2, true)
            }
          },
          {
            headerName: this.$t('Pricing.VolumePrice'), field: 'volumePrice', colId: 'volumePrice', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.formatNumber(params.value, 2, true)
            }
          },
          {
            headerName: this.$t('Pricing.WeightCost'), field: 'weightCost', colId: 'weightCost', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return ColumnUtils.formatNumber(params.value, 2, true)
            }
          },
          {
            headerName: this.$t('Pricing.VolumeCost'), field: 'volumeCost', colId: 'volumeCost', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return ColumnUtils.formatNumber(params.value, 2, true)
            }
          },
          { headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnPaymentFunc(params.value)
            }
          },
          {
            headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
            tooltip: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            }
          },

          { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200 },
          { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200 },
          { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200 },
          { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200 },
          { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 }
        ]
      },
      air: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'),
            field: 'pol',
            colId: 'pol',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Source'),
            field: 'source',
            colId: 'source',
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.POD'),
            field: 'pod',
            colId: 'pod',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            }
          },
          {
            headerName: this.$t('Pricing.Carrier_Air'), field: 'carrier', colId: 'carrier', width: 200,
            tooltip: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            }
          },
          { headerName: this.$t('Pricing.Flight'), field: 'flight', colId: 'flight', width: 200,
            cellRenderer: (params) => {
              return PriceAirUtil.serviceItemLabelFunction(params.data, params.value)
            } },
          {
            headerName: this.$t('Pricing.Aircraft'), field: 'aircraft', colId: 'aircraft', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.aircraftLabelFunction(params.value)
            }
          },
          { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200 },
          {
            headerName: 'M', field: 'minCharge', colId: 'minCharge', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            }
          },
          {
            headerName: 'N', field: 'step', colId: 'step', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            }
          },
          { headerName: '+45', field: 'p45', colId: 'p45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            } },
          { headerName: '+100', field: 'p100', colId: 'p100', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            } },
          { headerName: '+300', field: 'p300', colId: 'p300', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            } },
          { headerName: '+500', field: 'p500', colId: 'p500', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            } },
          { headerName: '+1000', field: 'p1000', colId: 'p1000', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
            } },
          { headerName: 'FSC', field: 'fsc', colId: 'fsc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.convertCurrencyColumnLabelFunc(params, this.showCurrency, this.filter.currency)
            } },
          { headerName: 'SSC', field: 'ssc', colId: 'ssc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.convertCurrencyColumnLabelFunc(params, this.showCurrency, this.filter.currency)
            } },
          {
            headerName: this.$t('Pricing.Agent'),
            field: 'bookingAgent',
            colId: 'bookingAgent',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName')
            },
            width: 200
          },
          { headerName: this.$t('Pricing.DepartureDayOfAir'), field: 'frequency8', colId: 'frequency8', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
            } },
          { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.daysColumnLabelFunc(params.data, params.value)
            } },
          { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 }
        ]
      },
      prePort: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'),
            field: 'pol',
            colId: 'pol',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Source'),
            field: 'source',
            colId: 'source',
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.POD'),
            field: 'pod',
            colId: 'pod',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Direct'),
            field: 'direct',
            colId: 'direct',
            cellRenderer: (params) => {
              return ColumnUtils.boolLabelFunc(params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            }
          },
          {
            headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
            tooltip: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            }
          },
          { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
          { headerName: this.$t('Pricing.ServiceMode'), field: 'serviceMode', colId: 'serviceMode', width: 200 },
          { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200 },
          { headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200 },
          { headerName: 'All In 20\'', field: 'eq20', colId: 'eq20', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: 'All In 40\'', field: 'eq40', colId: 'eq40', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: 'All In 40\'HC', field: 'eqHc', colId: 'eqHc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          }, { headerName: 'All In 45\'', field: 'eq45', colId: 'eq45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Sum'), field: 'amount', colId: 'amount', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost20'), field: 'cost20', colId: 'cost20', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost40'), field: 'cost40', colId: 'cost40', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.CostHC'), field: 'costHc', colId: 'costHc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost45'), field: 'cost45', colId: 'cost45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.VAT'), field: 'vat', colId: 'vat', width: 200 },
          { headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnPaymentFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200 },
          { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200 },
          { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200 },
          { headerName: this.$t('Pricing.Commodity'), field: 'commodity', colId: 'commodity', width: 200 },
          { headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.shareColumnLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
          { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200 },
          { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 },
          { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
            valueFormatter: (params) => {
              return CommonState.getNameByCode(PriceConstant.PRICE_ALL_TYPES, params.value)
            }
          },
          { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
          },
          { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
          },
          { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }
        ]
      },
      lastMile: {
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'),
            field: 'pol',
            colId: 'pol',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Source'),
            field: 'source',
            colId: 'source',
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.POD'),
            field: 'pod',
            colId: 'pod',
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Direct'),
            field: 'direct',
            colId: 'direct',
            cellRenderer: (params) => {
              return ColumnUtils.boolLabelFunc(params.value)
            },
            width: 200
          },
          {
            headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
            tooltip: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            },
            cellRenderer: (params) => {
              const value = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              return !value ? params.value : value
            }
          },
          {
            headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
            tooltip: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            },
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnCarrierFunc(params.data, params.value)
            }
          },
          { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
          { headerName: this.$t('Pricing.ServiceMode'), field: 'serviceMode', colId: 'serviceMode', width: 200 },
          { headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200 },
          { headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 200 },
          { headerName: 'All In 20\'', field: 'eq20', colId: 'eq20', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: 'All In 40\'', field: 'eq40', colId: 'eq40', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: 'All In 40\'HC', field: 'eqHc', colId: 'eqHc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          }, { headerName: 'All In 45\'', field: 'eq45', colId: 'eq45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Sum'), field: 'amount', colId: 'amount', width: 200,
            cellRenderer: (params) => {
              if (!params.value) return '0'
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost20'), field: 'cost20', colId: 'cost20', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost40'), field: 'cost40', colId: 'cost40', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.CostHC'), field: 'costHc', colId: 'costHc', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.Cost45'), field: 'cost45', colId: 'cost45', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.numberColumnLabelFunc(params.data, Number(params.value))
            }
          },
          { headerName: this.$t('Pricing.VAT'), field: 'vat', colId: 'vat', width: 200 },
          { headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.dataGridColumnPaymentFunc(params.value)
            }
          },
          { headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200 },
          { headerName: this.$t('Pricing.DepartureDay'), field: 'departureDay', colId: 'departureDay', width: 200 },
          { headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200 },
          { headerName: this.$t('Pricing.Commodity'), field: 'commodity', colId: 'commodity', width: 200 },
          { headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 200,
            cellRenderer: (params) => {
              return PriceUtils.shareColumnLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
          { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200 },
          { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            } },
          { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200 },
          { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200,
            valueFormatter: (params) => {
              return CommonState.getNameByCode(PriceConstant.PRICE_ALL_TYPES, params.value)
            }
          },
          { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
          },
          { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
          },
          { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: 'ETA', field: 'eta', colId: 'eta', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }
        ]
      },
      branchMap: new Map(),
      quotationDetail: { // 详情
        quotation: null,
        visible: false,
        isEditing: false,
        showDetail: false
      },
      inputAllowed: false,
      isEditAll: false,
      isDelete: false,
      isViewAll: $store.getters.isAdmin,
      allUsers: [],
      total: 0,
      partsUsers: []
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isPrePortOrLastMile() {
      return [PriceConstant.QUOTATION_PRE_PORT, PriceConstant.QUOTATION_LAST_MILE].indexOf(this.quotationType) > -1
    },
    columnDefs() {
      const columnDefs = this.commonColumnDefs
      if (PriceConstant.QUOTATION_PRE_PORT === this.quotationType) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_SubscribePOL'),
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.getRegionLabel(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getRegionLabel(params.data)
          }
        })
        columnDefs.push({
          headerName: this.$t('Partners.detailAddress'),
          colId: 'detailAddress',
          field: 'detailAddress',
          width: 120
        })
      }
      return columnDefs
    }
  },
  watch: {
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    }
  },
  created() {
    this.init()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onViewDetail', function(value) {
      context.onViewDetail(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 初始化数据
    async init() {
      await cache.load(cacheName.CONFIG)
      this.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC'
      if (this.toExoSystemHC) {
        this.filter.status2 = SystemConstants.QUOTE_STATUS_PENDING.code
      }
      this.branchMap = new Map()
      const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      if (officeList && officeList.length > 0) {
        for (const item of officeList) {
          if (!item.code || this.branchMap.has(item.officeId)) continue
          this.branchMap.set(item.officeId, item.code)
        }
      }
      this.isViewAll = this.$store.getters.isAdmin
      await SalesUtil.getInstance()
      const officeId = this.$store.getters.currentOfficeId

      const conMap = { clientId: null, active: true }
      // 加载销售下拉数据源
      await Promise.all([
        getJuniorSales(this.$store.getters.userId).then(res => {
          this.partsUsers = res.data
        }),
        getAllUsersByOffice({ officeId }).then(res => {
          this.allUsers = res.data
        }),
        queryQuotationClient({ condition: conMap }).then(res => {
          const clientRes = res.data
          if (clientRes && clientRes.length > 0) {
            this.filter.clientList = clientRes.filter(p => p.branchId === 1 || p.branchId === this.$store.getters.currentOfficeId)
          }
        })
      ])
      this.filter.salesList = this.isViewAll ? this.allUsers : this.partsUsers

      if (!this.isViewAll) {
        switch (this.quotationType) {
          case PriceConstant.QUOTATION_FCL:
            this.isViewAll = this.$checkPermission(['QFA'])
            break
          case PriceConstant.QUOTATION_AIR:
            this.isViewAll = this.$checkPermission(['QAA'])
            break
          case PriceConstant.QUOTATION_LCL:
            this.isViewAll = this.$checkPermission(['QLA'])
            break
          case PriceConstant.QUOTATION_PRE_PORT:
            this.isViewAll = this.$checkPermission(['role_PRQuotation_allQuotation'])
            break
          case PriceConstant.QUOTATION_LAST_MILE:
            this.isViewAll = this.$checkPermission(['role_PRQuotation_allQuotation'])
            break
          default:
            break
        }
      }
      switch (this.quotationType) {
        case PriceConstant.QUOTATION_FCL:
          this.inputAllowed = this.$checkPermission(['button_PRQuotationFCL_add'])
          this.isEditAll = this.$checkPermission(['button_PRQuotationFCL_editAll'])
          this.isDelete = this.$checkPermission(['button_PRQuotationFCL_delete'])
          break
        case PriceConstant.QUOTATION_AIR:
          this.inputAllowed = this.$checkPermission(['button_PRQuotationAir_add'])
          this.isEditAll = this.$checkPermission(['button_PRQuotationAir_editAll'])
          this.isDelete = this.$checkPermission(['button_PRQuotationAir_delete'])
          break
        case PriceConstant.QUOTATION_LCL:
          this.inputAllowed = this.$checkPermission(['button_PRQuotationLCL_add'])
          this.isEditAll = this.$checkPermission(['button_PRQuotationLCL_editAll'])
          this.isDelete = this.$checkPermission(['button_PRQuotationLCL_delete'])
          break
        case PriceConstant.QUOTATION_PRE_PORT:
        case PriceConstant.QUOTATION_LAST_MILE:
          this.isEditAll = this.$checkPermission(['button_PRQuotation_editAll'])
          break
        default:
          break
      }
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
      // console.log('isShowingMoreSearchCondition', this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.PlsInputQuotationNo')
    },
    // 查询
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery() {
      const keyWords = this.keyWords ? this.keyWords.trim() : ''
      if (!keyWords || keyWords.length === 0) {
        this.$message.warning(this.$t('Pricing.PlsInputQuotationNo'))
        this.simQueryPlaceholder = ''
        this.$refs.keyword.focus()
        return
      }
      this.proxy = {}
      this.proxy['quotationNo'] = keyWords
      this.proxy['quotationType'] = this.quotationType
      this.proxy['limited'] = this.limited
      this.proxy['showSimple'] = true
      // 没有权限则只能看下销售是自己的或者自己下属的单子
      if (!this.isViewAll && SalesUtil.juniorSales && SalesUtil.juniorSales.length > 0) {
        this.proxy['saleIds'] = SalesUtil.juniorSales.join(',')
      }
      this.proxy['branchId'] = this.$store.getters.currentOfficeId
      this.proxy['departmentId'] = this.$store.getters.currentDeptId
      this.loading = getLoading()
      queryQuotation(this.proxy).then((res) => {
        this.handleQueryData(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 高级查询
    toAdvancedQuery() {
      this.proxy = {}
      this.proxy['limited'] = this.limited
      this.proxy['quotationType'] = this.quotationType
      this.proxy['quotationNo'] = this.filter.quotationNo || ''
      this.proxy['inquiryPriceNo'] = this.filter.inquiryPriceNo || ''
      this.proxy['prePortQuotationNo'] = this.filter.prePortQuotationNo || ''
      this.proxy['lastMileQuotationNo'] = this.filter.lastMileQuotationNo || ''
      this.proxy['status2'] = this.filter.status2
      this.proxy['quotationMethod'] = this.filter.quotationMethod
      this.proxy['pol'] = this.filter.pol || ''
      this.proxy['pod'] = this.filter.pod || ''
      if (this.filter.clientId && this.filter.clientId > 0) {
        this.proxy['clientId'] = this.filter.clientId
      }
      // 是否可以查看全部权限
      if (this.isViewAll) {
        if (this.filter.sales && this.filter.sales > 0) {
          this.proxy['saleId'] = this.filter.sales
        }
      } else { // 没有权限则只能看下销售是自己的或者自己下属的单子
        if (SalesUtil.juniorSales && SalesUtil.juniorSales.length > 0) {
          this.proxy['saleIds'] = SalesUtil.juniorSales.join(',')
        }
      }
      if (this.filter.beginDate) {
        this.proxy['beginDate'] = this.filter.beginDate
      }
      if (this.filter.endDate) {
        this.proxy['endDate'] = this.filter.endDate
      }
      if (this.filter.beginDateCol) {
        this.proxy['beginDateCol'] = this.filter.beginDateCol
      }
      if (this.filter.endDateCol) {
        this.proxy['endDateCol'] = this.filter.endDateCol
      }
      this.proxy['booked'] = this.filter.ddlIsBooked
      this.proxy['clientType'] = !this.filter.ddlClientType ? 0 : parseInt(this.filter.ddlClientType)
      this.proxy['branchId'] = this.$store.getters.currentOfficeId
      this.proxy['departmentId'] = this.$store.getters.currentDeptId
      this.loading = getLoading()
      console.log('this.proxy===========', this.proxy)
      queryQuotation(this.proxy).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.loading.close()
      })
    },
    setNode() {
      if (!this.selectedItem) return
      this.gridApi.setFocusedCell(0, 'quotationNo')
      this.setRightData()
    },
    // 查询结果处理
    handleQueryData(res) {
      const _resMap = res.data
      if (!_resMap || _resMap.length === 0) {
        this.total = 0
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.rowData = []
        return
      }
      const arr = []
      let q = null
      if (_resMap) {
        for (const obj in _resMap) {
          q = _resMap[obj].quotation
          q.clientName = _resMap[obj].clientName
          arr.push(q)
        }
      }
      this.rowData = arr
      this.total = arr.length
      this.setNode()
    },
    // 重置查询条件
    resetSearch() {
      this.keyWords = ''
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.ddlClientType = 0
      this.filter.clientId = 0
      this.$refs.salesSelect.$refs.cargoAdvanceSelect.value = this.filter.sales = ''
      this.filter.ddlIsBooked = -1
      this.limited = 300
    },
    // 复制
    onCopy() {
      if (!this.selectedItem || !this.selectedItem.uuid) {
        this.$message.warning(this.$t('Pricing.PlsSelectRecord'))
        return
      }
      this.loading = getLoading()
      const conMap = {
        quotationUuid: this.selectedItem.uuid,
        quotationType: this.quotationType
      }
      // 复制走后端
      copyQuotation({ conMap }).then((res) => {
        const quotation = res.data
        if (quotation) {
          this.selectedItem = quotation
          this.rowData.splice(0, 0, quotation)
          this.setNode()
        }
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 新增
    onQuotation() {
      // console.log("onQuotation===>")
      // const user = this.$store.getters.userInfo
      // console.log("user===>", user)
      // if (!user.email || !user.userPhone || !user.fax) {
      //   this.$message.warning(this.$t('Pricing.PlsInputUserInfo'))
      //   return
      // }
      const quotation = new Quotation().fillDefaultValue().getData()
      quotation.beginDate = new Date()
      quotation.endDate = new Date()
      quotation.type = this.quotationType
      this.quotationDetail.quotation = quotation
      this.quotationDetail.showDetail = false
      this.quotationDetail.isEditing = true
      this.quotationDetail.visible = true
      this.$nextTick(() => {
        if (this.$refs.quotationDetail) {
          this.$refs.quotationDetail.originForm = this.quotationDetail.quotation
          this.$refs.quotationDetail.form = this.quotationDetail.quotation
        }
      })
    },
    onDelete() {
      if (!(this.selectedItem && this.selectedItem.uuid)) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      // 已生成订单的报价单不允许删除
      if (this.selectedItem.jobNo) {
        this.$message.warning(this.$t('Pricing.CheckQuotationDeleteTip'))
        return
      }
      if (!this.$store.getters.isAdmin && this.$store.getters.userId !== parseInt(this.selectedItem.createdBy)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeletedNotHavePermission'))
        return
      }
      this.loading = getLoading()
      deleteQuotationFunc({ uuid: this.selectedItem.uuid }).then((res) => {
        if (res.data === 'ok') {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          const index = this.rowData.findIndex(p => p.uuid === this.selectedItem.uuid)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
        } else if (res.data === 'noRole') {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeletedNotHavePermission'))
        } else if (res.data === 'haveCharge') {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeletedNotIntoBusiness'))
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_DeleteFailed'))
        }
      }).catch().finally(() => {
        this.loading.close()
      })
    },
    // 查看详情
    onViewDetail: async function(quotationUuid) {
      const quotation = this.rowData.find(x => x.uuid === quotationUuid)
      this.selectedItem = !quotation ? this.selectedItem : quotation
      // 海创 能查看到就能点进详情
      if (this.isViewAll || SalesUtil.juniorSaleMap[this.selectedItem.createdBy] || SalesUtil.juniorSaleMap[this.selectedItem.solveUserId] || this.toExoSystemHC) {
        await this.loadQuotationRelated(true)
        this.showDetailFunc()
      }
    },
    // 跳转详情处理
    showDetailFunc() {
      this.quotationDetail.quotation = this.selectedItem
      this.quotationDetail.showDetail = true
      console.log('SalesUtil.juniorSaleMap', SalesUtil.juniorSaleMap)
      this.quotationDetail.isEditing = this.isEditAll || (SalesUtil.juniorSaleMap && (SalesUtil.juniorSaleMap[this.selectedItem.createdBy] || SalesUtil.juniorSaleMap[this.selectedItem.solveUserId]))
      this.quotationDetail.visible = true
      this.$nextTick(() => {
        if (this.$refs.quotationDetail) {
          this.$refs.quotationDetail.originForm = this.quotationDetail.quotation
          this.$refs.quotationDetail.form = deepClone(this.quotationDetail.quotation)
          this.$refs.quotationDetail.init()
        }
      })
    },
    // 切换报价单带出详情
    changeQuotation(data) {
      if (!data || !data.uuid) return
      this.selectedItem = data
      if (this.isViewAll || SalesUtil.juniorSaleMap[this.selectedItem.createdBy] || SalesUtil.juniorSaleMap[this.selectedItem.solveUserId] || this.toExoSystemHC) {
        this.loadQuotationRelated()
      }
    },
    // 加载详情
    async loadQuotationRelated(isDetail = false) {
      const jobModel = new Quotation(this.selectedItem)
      this.clearRelatedData(isDetail, jobModel)
      await jobModel.loadQuotationRelated({
        quotation: isDetail,
        quotationFclDetail: this.quotationType === PriceConstant.QUOTATION_FCL,
        quotationLclDetail: this.quotationType === PriceConstant.QUOTATION_LCL,
        quotationAirDetail: this.quotationType === PriceConstant.QUOTATION_AIR,
        quotationChargeDetail: isDetail,
        quotationPrePortLastMileDetail: [PriceConstant.QUOTATION_PRE_PORT, PriceConstant.QUOTATION_LAST_MILE].indexOf(this.quotationType) > -1
      })
      this.setRightData()
    },
    // 清空子表数据
    clearRelatedData(isDetail = false, jobModel = {}) {
      if (this.quotationType === PriceConstant.QUOTATION_FCL) jobModel.quotationFclDetail = ''
      if (this.quotationType === PriceConstant.QUOTATION_LCL) jobModel.quotationLclDetail = ''
      if (this.quotationType === PriceConstant.QUOTATION_AIR) jobModel.quotationAirDetail = ''
      if ([PriceConstant.QUOTATION_PRE_PORT, PriceConstant.QUOTATION_LAST_MILE].indexOf(this.quotationType) > -1) {
        jobModel.prePortLastMileDetails = ''
      }
      if (isDetail) jobModel.quotationChargeDetail = ''
    },
    // 给右边显示列赋数据源
    setRightData() {
      if (this.quotationType === PriceConstant.QUOTATION_FCL) {
        this.fcl.rowData = this.selectedItem.quotationFclDetail || []
        this.fcl.gridApi.refreshCells({ force: true })
      }
      if (this.quotationType === PriceConstant.QUOTATION_LCL) {
        this.lcl.rowData = this.selectedItem.quotationLclDetail || []
        this.lcl.gridApi.refreshCells({ force: true })
      }
      if (this.quotationType === PriceConstant.QUOTATION_AIR) {
        this.air.rowData = this.selectedItem.quotationAirDetail || []
        this.air.gridApi.refreshCells({ force: true })
      }
      if (this.quotationType === PriceConstant.QUOTATION_PRE_PORT) {
        this.prePort.rowData = this.selectedItem.prePortLastMileDetails || []
        // this.prePort.gridApi.refreshCells({ force: true })
      }
      if (this.quotationType === PriceConstant.QUOTATION_LAST_MILE) {
        this.lastMile.rowData = this.selectedItem.prePortLastMileDetails || []
        // this.lastMile.gridApi.refreshCells({ force: true })
      }
    },
    selectBlur() {
      if (!this.limited) this.limited = 300
    },
    // 各列表 API 初始化
    onGridReady(params) {
      this.gridApi = params.api
    },
    onFclGridReady(params) {
      this.fcl.gridApi = params.api
    },
    onLclGridReady(params) {
      this.lcl.gridApi = params.api
    },
    onAirGridReady(params) {
      this.air.gridApi = params.api
    },
    onPrePortGridReady(params) {
      this.prePort.gridApi = params.api
    },
    onLastMileGridReady(params) {
      this.lastMile.gridApi = params.api
    },
    saveSuccess(quotation) {
      if (quotation && quotation.quotationNo) {
        this.loading = getLoading()
        queryQuotation({ quotationNo: quotation.quotationNo, branchId: this.$store.getters.currentOfficeId, departmentId: this.$store.getters.currentDeptId, quotationType: this.quotationType }).then((res) => {
          let q = null
          if (res.data) {
            for (const obj in res.data) {
              q = res.data[obj].quotation
              q.clientName = res.data[obj].clientName
            }
          }
          let update = false
          for (const item of this.rowData) {
            if (item.uuid && q.uuid && item.uuid === q.uuid) {
              Object.assign(item, q)
              update = true
              break
            }
          }
          if (!update) {
            this.rowData.push(q)
          }
          this.gridOptions.api.refreshCells({ force: true })
        }).finally(() => {
          this.loading.close()
        })
      }
    }
  }
}
</script>

